import script from "./restPwd.vue?vue&type=script&setup=true&lang=js"
export * from "./restPwd.vue?vue&type=script&setup=true&lang=js"

import "./restPwd.vue?vue&type=style&index=0&id=b3590d74&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3590d74"]])

export default __exports__